import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Card, Spin, Space, Switch, Button, List } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useParams, Link, useHistory } from 'react-router-dom';
import SwaggerUI from 'swagger-ui-react';
import { getApiDetail } from '../../apis/apis';
import { getUserScope } from '../../apis/scope';
import HomePageLayout from '../Layout/HomePageLayout';
import { openErrorNotification } from '../../utils/notification';
import ScopeInfo from './ScopeInfo';
import MethodTag from '../Method';

const styles = {
  'primaryLabel': {
    fontSize: 18,
    fontWeight: 700
  },
  secondLabel: {
    fontSize: 14,
    fontWeight: 400
  }
}

const ApiDetail = () => {

  const [apiDetail, setDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const [scopeList, setScopeList] = useState([]);
  const history = useHistory();

  const { id } = useParams();

  if (!id) {
    history.push('/not-found')
  }

  const fetchApiDetail = useCallback(async () => {

    try {
      setLoading(true);
      const scopeResp = await getUserScope();
      console.log(scopeResp?.data);
      setScopeList(scopeResp?.data || [])
      setLoading(false);
    } catch (error) {
      setLoading(false);
      openErrorNotification('Error Code: 402. Our system can not fetch data! Please try again')
      console.log(error);
    }

    try {
      if (id ?? false) {
        setLoading(true);
        const apiRes = await getApiDetail(id);
        setDetail(apiRes);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      openErrorNotification('Our system can not fetch data! Please try again')
      console.log(error);
    }
    
  }, [id])

  useEffect(() => {
    fetchApiDetail();
  }, [fetchApiDetail]);


  return (
    <HomePageLayout>
      <Spin spinning={loading}>
        <div>
          <Button type="primary" size="large">
            <Link to={`/api-docs/${apiDetail?.apiDocId}`}><ArrowLeftOutlined /> Back</Link>
          </Button>
        </div>
        <br></br>
        <Card title={<p style={{ ...styles.primaryLabel, marginBottom: 0 }}>{apiDetail.path}</p>}>
          <div>
            <Space>
              <p style={styles.primaryLabel}>Method:</p>
              <p>
                <MethodTag style={styles.secondLabel} method={apiDetail.method} />
              </p>
            </Space>
          </div>
          {
            scopeList && scopeList.length > 0
            && apiDetail?.scopes
            && apiDetail?.scopes.length > 0
            && (<div>
              <Space>
                <ScopeInfo
                  labelStyle={styles.primaryLabel}
                  options={scopeList}
                  value={apiDetail?.scopes || []}
                />
              </Space>
            </div>)
          }
        </Card>
        <Card>
          {
            apiDetail && apiDetail.combinedContent && <SwaggerUI spec={JSON.parse(apiDetail.combinedContent)} />
          }
        </Card>
      </Spin>
    </HomePageLayout>
  )
}

export default ApiDetail;